module.exports = __webpack_public_path__ + "static/media/6.6293b6da.png";